import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source, configuration) {
        super(configuration);
        this.g2y_1 = source;
      }
      l2x() {
        return this.g2y_1;
      }
      m2x(position) {
        return position < this.l2x().length ? position : -1;
      }
      a2u() {
        var source = this.l2x();
        var cpos = this.z2m_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.z2m_1 = cpos;
          return charToTokenClass(c);
        }
        this.z2m_1 = source.length;
        return 10;
      }
      w2t() {
        var current = this.z2m_1;
        if (current === -1)
          return false;
        var source = this.l2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.z2m_1 = current;
          return this.p2x(c);
        }
        this.z2m_1 = current;
        return false;
      }
      o2x() {
        var current = this.z2m_1;
        if (current === -1)
          return current;
        var source = this.l2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.z2m_1 = current;
        return current;
      }
      h2u(expected) {
        if (this.z2m_1 === -1) {
          this.q2x(expected);
        }
        var source = this.l2x();
        var cpos = this.z2m_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.z2m_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.q2x(expected);
        }
        this.z2m_1 = -1;
        this.q2x(expected);
      }
      n2u() {
        this.h2u(_Char___init__impl__6a9atx(34));
        var current = this.z2m_1;
        var closingQuote = indexOf(this.l2x(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.y2t();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false && this.z2m_1 > 0 ? this.z2m_1 - 1 | 0 : this.z2m_1;
          var s = this.z2m_1 === charSequenceLength(this.l2x()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.l2x(), position));
          var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.p2s(tmp$ret$1, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.l2x(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.l2x(), this.z2m_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.z2m_1 = closingQuote + 1 | 0;
        return substring(this.l2x(), current, closingQuote);
      }
      p2u(keyToMatch, isLenient) {
        var positionSnapshot = this.z2m_1;
        try {
          if (!(this.a2u() === 6))
            return null;
          var firstKey = this.k2u(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.r2x();
          if (!(this.a2u() === 5))
            return null;
          return this.k2u(isLenient);
        }finally {
          this.z2m_1 = positionSnapshot;
          this.r2x();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.l2m_1.n2o_1 ? new (StringJsonLexer())(source, json.l2m_1) : new (StringJsonLexerWithComments())(source, json.l2m_1);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
